import imageAdapters from "./adapters";

/**
 * @callback makeImageSrc
 * @param {string} src
 * @param {string} format
 * @param {number} [size]
 * @param {string} [bg]
 * @param {string} [extension]
 * @param {boolean} [cover=false]
 * @param {string} [baseUrl=""]
 * @param {object} [focalPoint]
 * @returns {string}
 */

/**
 * @type {makeImageSrc}
 */
const makeImageSrc = (
  src,
  format,
  size,
  bg,
  extension,
  cover,
  baseUrl,
  focalPoint = undefined
) => {
  if (src.startsWith("data:image")) {
    return src;
  }

  return imageAdapters.makeImageSrc(
    src,
    format,
    size,
    bg,
    extension,
    cover,
    baseUrl,
    focalPoint
  );
};

export default makeImageSrc;
